<template>
    <tr class="transition duration-200 hover:bg-gray-100" class2="cursor-pointer">
        <td class="border-b px-2 py-1 text-sm">
            <view-ebay-link :store="store" :search-query="category.name">
                <div class="font-semibold sm:whitespace-no-wrap">
                    {{ store.name }}
                </div>

                <div class="store-avatar mt-2" class2="avatar">
                    <img :src="store.image_url" :alt="store.name" class="block p-1 rounded-circle bg-white w-10 h-10" />
                </div>
            </view-ebay-link>
        </td>
        <td class="border-b px-2 py-1 text-sm">
            <view-ebay-link :store="store" :search-query="category.name">
                {{ category.name }} - all models
            </view-ebay-link>
        </td>
        <td class="border-b px-2 py-1">
            <span class="badge badge-success text-xs rounded">
                In Stock
            </span>
        </td>
        <td class="border-b px-2 py-1">
            <h6 class="font-semibold text-gray-800 text-base">
                <span>
                    $ $ $
                    <!-- &ndash; -->
                </span>
            </h6>
        </td>
        <td class="border-b px-2 py-1 text-xs text-gray-600 hidden sm:table-cell">
            <span>
                &ndash;
            </span>
        </td>
        <td class="border-b px-2 py-1 hidden sm:table-cell">
            <!--  -->
        </td>
    </tr>
</template>

<script>
// import EbayMixin from '../../mixins/ebay';

export default {
    // mixins: [EbayMixin],

    props: [
        'category',
        'store'
    ],

    data: () => ({}),

    created() {},

    mounted() {},

    computed: {
        // searchQuery() {
        //     return this.category.name;
        // }
    },

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
